import { CommonModule } from "@angular/common";
import { Component, Injectable, Input } from "@angular/core";
import { DxPopupService } from "devextreme-angular/ui/popup";
import { NgxBarcode6Module } from "ngx-barcode6";

@Injectable({
  providedIn: "root",
})
export class LexiPopupService {
  constructor(private readonly popupService: DxPopupService) {}

  openBarcodePopup(barcode: string) {
    const popupRef = this.popupService.open(BarcodeSymbolComponent, {
      showTitle: true,
      title: "Code-barres",
      container: "html",
      width: 650,
      height: 300,
      showCloseButton: true,
      hideOnOutsideClick: true,
    });

    popupRef.contentRef.instance.barcode = barcode;
  }
}

@Component({
    selector: "app-barcode-symbol",
    imports: [CommonModule, NgxBarcode6Module],
    template: `
    <ngx-barcode6
      style="display: flex;justify-content: center;"
      [bc-format]="'CODE128'"
      [bc-value]="barcode"
      [bc-display-value]="true"
    ></ngx-barcode6>
  `
})
export class BarcodeSymbolComponent {
  @Input() barcode: string = "";
}
